










import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import UpForm from '@/components/Common/Form/UpForm.vue';
import {
  User,
  SelectOption,
  FormOption,
  FormField,
  Role,
  Permissions
} from '@/types';
import { userSvc } from '@/services';
import { Getter } from 'vuex-class';

@Component({
  name: 'user-form',
  components: { UpForm }
})
export default class UserForm extends Vue {
  @Prop({ type: Object, default: () => ({}) })
  private value!: User;

  @Getter
  isMe!: (id: number) => boolean;

  @Getter
  getRoleOptions!: SelectOption[];

  @Getter
  private hasPermission!: (permission: Permissions) => boolean;

  private busy: boolean = false;

  private userModel: User = {};

  get formOptions(): FormOption {
    return {
      title: 'Edit User',
      deleteBtnText: 'Delete',
      deleteable:
        this.hasPermission(Permissions.DELETE_USER) &&
        !this.isMe(this.userModel.id as number)
    };
  }

  get fields(): FormField[] {
    return [
      {
        type: 'input',
        subType: 'text',
        key: 'name',
        label: 'Name',
        required: true,
        placeholder: 'Please enter user name'
      },
      {
        type: 'input',
        subType: 'email',
        key: 'email',
        label: 'Email',
        required: true,
        placeholder: 'Please enter email'
      },
      {
        type: 'select',
        subType: 'multiple',
        options: this.getRoleOptions,
        key: 'roles',
        label: 'Roles',
        required: true,
        hide: !this.hasPermission(Permissions.UPDATE_USER)
      }
    ];
  }

  async onSubmit(): Promise<any> {
    this.busy = true;
    try {
      const user: User = await this.$store.dispatch('updateUser', {
        id: this.userModel.id,
        name: this.userModel.name,
        email: this.userModel.email,
        roles: this.userModel.roles
      });
      this.$emit('input', user);
      this.$notify.success('Profile Updated.');
    } catch (e) {
      this.$notify.error('Fail to Update User');
    }
    this.busy = false;
  }

  async onDelete(): Promise<any> {
    this.busy = true;
    try {
      await userSvc.deleteUser(this.userModel.id as number);
      this.$notify.success('User Deleted.');
      this.$router.push({ name: 'users' });
    } catch (e) {
      this.$notify.error('Fail to delete this user.');
    }
    this.busy = false;
  }

  @Watch('value')
  onValueUpdated(value: User) {
    this.userModel = { ...this.userModel, ...value };
    // @ts-ignore
    this.userModel.roles = this.value.roles!.map(r => r.id);
  }
}
